/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DropdownModelSingleValue, IAviDropdownOption } from './avi-dropdown.types';

/**
 * @description Pipe to filter dropdown options by hiddenValues.
 * @author alextsg
 */
@Pipe({
    name: 'isHidden',
    standalone: true,
})
export class IsHiddenPipe implements PipeTransform {
    public transform(
        options: IAviDropdownOption[],
        hiddenValues: DropdownModelSingleValue[] = [],
    ): IAviDropdownOption[] {
        const hiddenValuesSet = new Set(hiddenValues);

        return options.filter(({ value }) => !hiddenValuesSet.has(value));
    }
}
